var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"display":"block"},attrs:{"size":"small","options":_vm.options,"placeholder":"请选择所在区域","filterable":"","props":_vm.checkstrictly},on:{"change":_vm.changeVal},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}})
}
var staticRenderFns = []

export { render, staticRenderFns }